import { z } from 'zod';
import { citySchema } from './city-schema';
import { companySchema } from './company-schema';
import { imageSchema } from './image-schema';
import { locationSchema } from './location-schema';
import { metaSchema } from './meta-schema';
import { officeSchema } from './office-schema';
import { pageConfigurationSchema } from './page-configuration-schema';
import { personSchema } from './person-schema';

export type TCounty = z.infer<typeof countySchema>;

export const countySchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    companies: z.object({
      data: z.array(companySchema),
    }),
    offices: z.object({
      data: z.array(officeSchema),
    }),
    cities: z.object({
      data: z.array(citySchema),
    }),
    people: z.object({
      data: z.array(personSchema),
    }),
    configuration: pageConfigurationSchema,
    background: imageSchema,
    meta: metaSchema,
    location: locationSchema,
  }),
});
